import { getStatementList, getFortisOnboardingRequestUrl } from 'helpers/api';
import { isProd } from 'config/config';

import Vue from 'vue/dist/vue';

const statementsEl = document.getElementById('statements-billing');
if (statementsEl) {
    Vue.component('ach-modal', {
        template: '#ach-modal-template',
        data: function () {
            return {
                isVisible: false,
                fortisOnboardingUrl: '',
            };
        },
        methods: {
            async getFortisOnboardingRequest() {
                this.fortisOnboardingUrl = '';

                const postRequest = await getFortisOnboardingRequestUrl();
                if (postRequest.status === 200) {
                    this.fortisOnboardingUrl = postRequest.data;
                }
            },

            showModal: function () {
                this.isVisible = true;
            },

            hideModal: function () {
                this.isVisible = false;

                this.getFortisOnboardingRequest();
            },
        },

        created() {
            this.getFortisOnboardingRequest();
        },
    });

    new Vue({
        el: '#statements-billing',

        data: {
            historicalenabled: false,
            statementPayment: false,
            statements: [],
            historicalempty: false,
            fields: {
                statementid: '0',
                year: {
                    value: '',
                    filled: true,
                },
                month: {
                    value: '',
                    filled: true,
                },
                dest: {
                    value: 'email',
                    filled: true,
                },
                emailFax: {
                    value: '',
                    filled: true,
                },
            },
            dropdownMonths: [],
            allMonths: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
            showSuccess: false,
            showError: false,
            isFetching: false,
            statementsPayment: [],
        },

        computed: {
            dropdownYears: function () {
                const currentYear = new Date().getFullYear();

                let displayedYears = [];

                for (let i = 2006; i <= currentYear; i++) {
                    displayedYears.push(i);
                }

                return displayedYears.reverse();
            },

            selectedMonth: function () {
                return this.allMonths[this.fields.month.value - 1];
            },

            postValues: function () {
                const postObj = { ...this.fields };
                let values = {};

                Object.keys(postObj).forEach(function (key) {
                    values[key] = postObj[key].value;
                });

                return values;
            },
        },

        methods: {
            updateMonthsDropdown: function (event) {
                const currentYear = new Date().getFullYear().toString();
                const currentMonth = new Date().getMonth();

                if (!this.fields.year.value || currentYear !== event.target.value) {
                    this.dropdownMonths = [...this.allMonths];
                } else {
                    this.fields.month.value = '';
                    this.dropdownMonths.length = 0;

                    for (let i = 0; i < currentMonth + 1; i++) {
                        this.dropdownMonths.push(this.allMonths[i]);
                    }
                }
            },

            openStatement: function (open, historical = false) {
                var url = '';
                if (historical) {
                    if (open) {
                        url = isProd
                            ? `/Print/HistoricalStatement?statementId=${this.fields.statementid}&open=true`
                            : `https://pd.web.local/Print/HistoricalStatement?statementId=${this.fields.statementid}&open=${true}`;
                    } else {
                        url = isProd
                            ? `/Print/HistoricalStatement?statementId=${this.fields.statementid}&open=false`
                            : `https://pd.web.local/Print/HistoricalStatement?statementId=${this.fields.statementid}&open=${false}`;
                    }
                } else {
                    if (open) {
                        url = isProd ? `/Print/Statement?open=true` : `https://pd.web.local/Print/Statement?open=${true}`;
                    } else {
                        url = isProd ? `/Print/Statement?open=false` : `https://pd.web.local/Print/Statement?open=${false}`;
                    }
                }

                window.open(url, '_blank');
            },

            loadHistoricalStatements: async function () {
                const { data = {}, status } = await getStatementList();
                console.log(data);
                if (status == 200) {
                    if (!data.records.length) {
                        this.historicalempty = true;
                    } else {
                        this.statements = data.records;
                    }
                }
                this.historicalenabled = !this.historicalenabled;
            },

            // loadStatementPayment: async function () {
            //   const res = await getStatementPaymentList()
            //   console.log("Status", res.status)
            //   if (res.status == 200) {
            //     if (!res.data.lines || !res.data.lines.length) {
            //       this.historicalempty = true
            //     } else {
            //       this.statements = res.data
            //     }
            //     console.log("StatementsPayment", res.data)
            //   }
            //   this.historicalenabled = !this.historicalenabled
            // },

            isFormFilled: function () {
                let filled = true;

                const checkFields = function (obj) {
                    Object.keys(obj).forEach(function (key) {
                        if (typeof obj[key].value === 'string' && !obj[key].value.replace(/\s+/g, '').length) {
                            obj[key].filled = false;
                            filled = false;
                        } else if (obj[key].value) {
                            obj[key].filled = true;
                        } else {
                            obj[key].filled = false;
                            filled = false;
                        }
                    });
                };

                checkFields(this.fields);

                return filled;
            },
        },

        mounted() {
            this.updateMonthsDropdown();
        },
    });
}
